import SiteApi from "./SiteApi";
import PartnerApi from "./PartnerApi";
import CompanyApi from "./CompanyApi";
import GroupApi from "./GroupApi";
import ComputerApi from "./ComputerApi";
import UserApi from "./UserApi";
import HashInspectionApi from "./HashInspectionApi";
import AssetsApi from "./AssetsApi";
import PolicyReviewApi from "./PolicyReviewApi";
import AlarmApi from "./AlarmApi";

export default {
  sites: SiteApi,
  companies: CompanyApi,
  partners: PartnerApi,
  groups: GroupApi,
  users: UserApi,
  computers: ComputerApi,
  hashInspections: HashInspectionApi,
  assets: AssetsApi,
  policyReview: PolicyReviewApi,
  alarms: AlarmApi,
};
